import { InjectionToken } from '@angular/core';
import { WORKFLOW_MODULE_ID } from 'constants/workflow.constants';

export interface CertificationPhaseMappingConfig {
  backUrl: string;
  getCertificateAction: any;
  workflowType: WORKFLOW_MODULE_ID;
}

export const CERTIFICATION_PHASE_MAPPING_CONFIG = new InjectionToken<CertificationPhaseMappingConfig>(
  'CertificationPhaseMappingConfig',
);
